import React from 'react';
import { Header } from '../../node_modules/semantic-ui-react';

export default function Review(props) {
    return(
        <div className='section' id='education'>
            <Header as='h3'>
                Academic Services
            </Header>
            <div className="section-content">
                <div><b>Reviewer</b>: CSCW 2020, CHI LBW 2019</div>
                <div><b>Student Volunteer</b>: CHI 2019</div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Review.jsx